import { render, staticRenderFns } from "./PartnerOrdersStatus.vue?vue&type=template&id=74f1b4bd&"
import script from "./PartnerOrdersStatus.vue?vue&type=script&lang=js&"
export * from "./PartnerOrdersStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports